import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";
import { AiOutlineArrowRight, AiOutlineArrowUp, AiFillCaretRight } from "react-icons/ai";

const IndoHomeLoan = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-11.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "Features",
      content: ["Low interest rate", "Tailored repayment periods up to 300 months"],
    },
    {
      title: "Eligibility",
      content: [
        "Salaried employees on either permanent or contractual terms with reputable corporate institution such as government departments, parastatals and the private sector",
        "Self employed business people with legal identifiable and regular source of income",
        "Parents, spouses and children may be accepted as co borrowers to improve the entitlement/repayment capacity of the borrower. However, the number of co-borrowers should not exceed two.",
        "Indo Home loan is available to existing customers of the bank who have maintained banking relationships for at six months.",
      ],
    },
    {
      title: "Currency",
      content: ["ZMW", "USD (subject to a maximum tenure) of 84 months and subject to the borrower demonstrating their ability to generate foreign currency inflows over the proposed tenure."],
    },
    {
      title: "Interest Rate",
      content: ["BOZ Policy Rate plus margin"],
    },
    {
      title: "Purpose of the Loan",
      content: [
        "Outright purchase of a readymade house.",
        "Purchase of a plot and construction of a house or construction of a house on an already existing plot within a maximum period of 18 months.",
        "Home improvements – for repairs, renovation/alteration/extension in the existing house/flat",
        "Takeover/refinancing of home loan availed from other financial intuitions subject to terms and conditions",
      ],
    },
    {
      title: "Security",
      content: ["Legal mortgage of property purchased or developed out of bank ﬁnance"],
    },
    {
      title: "Repayment Period",
      content: [
        "For salaried borrowers – 300 months within the borrower attaining the age of 60 years.",
        "For non-salaried borrowers – 300 months within the borrower attaining 60 years. In the case of repairs/renovation/alteration of existing house/flat repayment should be made within maximum period of 120 months.",
      ],
    },
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:credit@izb.co.zm">credit@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    },
  ];

  return (
    <>
      <Breadcrumb Heading="Indo Home Loan" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <SavePlusAccountComponent heading="Indo Home Loan" subHeading="Know About" btnTxt="Apply Now" img={img1} logo={true} />
      <ContainsArea />

      <section className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 justify-content-center">
              <div className="faq-style1__content">
                <ul className="accordion-box mt-5">
                  {accordionData.map((item, index) => (
                    <li className="accordion block active-block" key={index}>
                      <div
                        className="acc-btn active"
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(index)}
                      >
                        <div className="icon-outer text-white">
                          {openIndex === index ? <AiOutlineArrowRight /> : <AiOutlineArrowUp />}
                        </div>
                        <h3 className="text-white">{item.title}</h3>
                      </div>
                      {openIndex === index && (
                        <div className="acc-content current px-5">
                          {item.content.map((point, idx) => (
                            <p key={idx} className="">
                              <AiFillCaretRight className="me-1 accordion-icon" />
                              <span className="mt-1" dangerouslySetInnerHTML={{ __html: point }} />
                            </p>
                          ))}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AllAcountsSection />
    </>
  );
};

export default IndoHomeLoan;